import state from './moduleSocialMediaManagementState.js'
import mutations from './moduleSocialMediaManagementMutations.js'
import actions from './moduleSocialMediaManagementActions.js'
import getters from './moduleSocialMediaManagementGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

